<template>
  <div>
    <template v-if="categoryInput">
      <div
        v-for="(group, groupIndex) in categoryGroups"
        :key="groupIndex"
        class="accommodation-form-fields__category-group mb-3"
      >
        <div class="d-flex gap-2 align-items-end mb-2">
          <div class="flex-grow-1">
            <label class="form-label" :for="`${idPrefix}-category-title-${groupIndex}`">Bezeichnung der Auswahl</label>
            <input
              :id="`${idPrefix}-category-title-${groupIndex}`"
              class="form-control"
              type="text"
              :value="group.title"
              :list="categoryTitleSuggestions.length ? datalistId : undefined"
              placeholder="Zimmerkategorien"
              @input="$emit('update-category-title', groupIndex, $event.target.value)"
            >
          </div>
          <button
            v-if="groupedCategories"
            type="button"
            class="btn btn-outline-danger"
            aria-label="Auswahl entfernen"
            @click="$emit('remove-category-group', groupIndex)"
          >Entfernen</button>
        </div>

        <label class="form-label">Auswahlmöglichkeiten</label>
        <div v-for="(option, optionIndex) in group.options" :key="optionIndex" class="input-group mb-2">
          <input
            class="form-control"
            type="text"
            :value="option"
            :placeholder="categoryPlaceholder(groupIndex)"
            @input="$emit('update-category-option', groupIndex, optionIndex, $event.target.value)"
          >
          <button
            type="button"
            class="btn btn-outline-danger"
            aria-label="Auswahlmöglichkeit entfernen"
            @click="$emit('remove-category-option', groupIndex, optionIndex)"
          >Entfernen</button>
        </div>
        <button type="button" class="btn btn-outline-primary btn-sm" @click="$emit('add-category-option', groupIndex)">
          Auswahlmöglichkeit hinzufügen
        </button>
      </div>

      <datalist v-if="categoryTitleSuggestions.length" :id="datalistId">
        <option v-for="suggestion in categoryTitleSuggestions" :key="suggestion" :value="suggestion" />
      </datalist>

      <button
        v-if="groupedCategories"
        type="button"
        class="btn btn-outline-secondary btn-sm"
        @click="$emit('add-category-group')"
      >Weitere Auswahl anlegen</button>
    </template>

    <div v-if="availableServices.length" :class="{'mt-3': Boolean(categoryInput)}">
      <span class="form-label d-block">Angebotene Services</span>
      <div class="row g-2">
        <div v-for="(services, columnIndex) in serviceColumns" :key="columnIndex" class="col-12 col-md-6 col-xl-4">
          <label v-for="service in services" :key="service" class="form-check mb-2">
            <input
              class="form-check-input"
              type="checkbox"
              :checked="selectedServices.includes(service)"
              @change="$emit('toggle-service', service, $event.target.checked)"
            >
            {{ service }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    idPrefix: {type: String, required: true},
    categoryInput: {type: String, default: ''},
    categoryGroups: {type: Array, default: () => []},
    categoryTitleSuggestions: {type: Array, default: () => []},
    availableServices: {type: Array, default: () => []},
    selectedServices: {type: Array, default: () => []},
  },
  emits: [
    'update-category-title',
    'update-category-option',
    'add-category-group',
    'remove-category-group',
    'add-category-option',
    'remove-category-option',
    'toggle-service',
  ],
  computed: {
    datalistId() {
      return `${this.idPrefix}-category-title-suggestions`
    },
    groupedCategories() {
      return this.categoryInput === 'grouped_categories'
    },
    serviceColumns() {
      const columns = []
      for (let index = 0; index < this.availableServices.length; index += 4) {
        columns.push(this.availableServices.slice(index, index + 4))
      }
      return columns
    },
  },
  methods: {
    categoryPlaceholder(groupIndex) {
      if (!this.groupedCategories) return 'z. B. Doppelzimmer'
      return groupIndex === 0 ? 'z. B. Wohnmobil bis 8 m' : 'z. B. Ferienhaus'
    },
  },
}
</script>

<style scoped>
.accommodation-form-fields__category-group {
  border: 1px solid var(--bs-border-color);
  padding: 1rem;
}
</style>
